<template lang="pug">
  .agricultural-trainee
    section.section-1
      .container
        .search-wrap
          .find-btn-wrap
            router-link.main-btn.col-white.bg-red( :to="{name: 'Workers', params: {lang: getLanguage}, query: {tr: true, ct: 1}}")
              img(src="/webapp/images/home/employer-search.png")
              span {{ gettext('Find an agricultural trainee') }}
                .mdi.mdi-chevron-right
            router-link.main-btn.col-white.bg-black(:to="{name: 'FindJob', params: {lang: getLanguage}, query: {emt: 1, ct: 1}}")
              img(src="/webapp/images/home/job-seaker-search.png")
              span {{ gettext('Find a traineeship') }}
                .mdi.mdi-chevron-right
    section.section-2
      .block-wrap.opened
        .block
          .video(@click="showVideoModal=!showVideoModal")
            img(src="/webapp/images/agricultural-trainee/video.png")
            .play
              i.mdi.mdi-triangle
        .block
          .text
            p {{ gettext('Are you interested in working abroad in agriculture area? Are you enrolled in educational institution with focus on agriculture? Are you out-going person with motivation to work? If yes, do not hesitate to contact us and we are going to find you perfect job for you. We will find you job in agriculture area which suits your need. We can provide you a traineeship on dairy, pig, mink farms, poultry and greenhouses.') }}
            p
              b {{ gettext('How does it work:') }}
            p
              ul
                li
                  b {{ gettext('Step') }} 1 –
                  |  {{ gettext('Send us your CV') }}
                li
                  b {{ gettext('Step') }} 2 –
                  |  {{ gettext('We will process your CV and we will find most suitable job for you') }}
                li
                  b {{ gettext('Step') }} 3 –
                  |  {{ gettext('We will help you with all the documentation and then you are ready to work') }}
            .main-btn.col-white.bg-black.see-more(@click="showMore = true" v-if="!showMore") {{ gettext('See more') }}
      .block-wrap.opened
        .block.whide
          .text.no-pading
            .hidden(v-if="showMore")
              p.no-padding {{ gettext('Registration in Denmark – When you arrive to Denmark you need to register for your CPR number in order to work in Denmark. We will help you with the application. Below you can find a booklet and list of all documents which you need have while applying for CPR and additional information as well.') }}
              p.no-padding {{ gettext('Upon arriving to Denmark, your employee is going to meet you at the airport if they are nearby the airport. (However, if they are living further, it would be nice if you could take bus or train to the city or near the city where your future job is located.') }}
              .main-btn.col-white.bg-black.see-more(@click="showMore = false" v-if="showMore") {{ gettext('Close') }}

    learn
    //Hide the form
    section.section-6.contact-us(v-if="false")
      .blocks-wrap
        .section-6-wrap
          .contact-form.container
            .left
              span.note {{ gettext('Quick traineeship registration') }}
              span.big {{ gettext('Please fill out the form in order for faster registration.') }}
              span {{ gettext('We are looking forward to find a traineeship for you!') }}
            .right.gray-bg(v-if="!thankModal")
              .tile.field
                .field-body
                  input.input(
                  :placeholder="gettext('First Name')"
                  v-model="form.firstName"
                  )
              .tile.field
                .field-body
                  input.input(
                  :placeholder="gettext('Last Name')"
                  v-model="form.lastName"
                  )
              .tile.field
                .field-body
                  v-phone-input(
                  name="phone"
                  v-model="form.phone"
                  @blur="validateData('phone')"
                  :class="{'is-danger': $v.form.phone.$error, 'is-empty': !form.phone}"
                  @onInput="form.phone = $event.number"
                  ref="phoneInput"
                  :phone="form.phone"
                  )
              .tile.field
                .field-body
                  input.input(
                  :placeholder="gettext('Email')"
                  v-model="form.email"
                  @blur="validateData('email')"
                  :class="{'is-danger': $v.form.email.$error, 'is-empty': !form.email}"
                  )
              .tile.field
                .field-body
                  ajax-multiselect.wide(
                  v-model="form.country"
                  :labelText="gettext('Your nationality')"
                  :itemName ="'name'"
                  :action="{method: 'receiveNationalities', params:{lang: getLanguage, filters: ['for_jobseeker_profile']}}",
                  :multiple="false"
                  :searchable="true"
                  :hideSelected="true"
                  :closeOnSelect="true"
                  )
              .tile.field
                .field-body
                  input.input(
                  :placeholder="gettext('Age')"
                  type="number"
                  v-model="form.age"
                  @blur="validateData('age')"
                  :class="{'is-danger': $v.form.age.$error, 'is-empty': !form.age}"
                  )
              .tile.field
                .field-body
                  input#custom-checkbox.is-checkradio.custom-checkbox(
                  type="checkbox"
                  v-model="form.agree"
                  )
                  label.checkbox(for="custom-checkbox")
                    | {{ gettext('I agree to the') }} &nbsp;
                    router-link(:to="`/${getLanguage}/terms-and-conditions`" target='_blank') {{ gettext('terms and conditions') }}
                label.label.is-hidden-mobile
              .tile.btns
                .main-btn.col-white.bg-red(
                @click="send()"
                :disabled="$v.$invalid || (!$auth.check() && !form.agree) || loading"
                ) {{ gettext('Send') }}
    workers
    jobs
    section.section-6
      .container
        .block-wrap
          .section-6-wrap
            h3.headline.mb-3 {{ gettext('What do you need to be a trainee') }}
            .trainee-block
              .trainee-item
                .mdi.mdi-cake
                .head {{ gettext('Age between 18-29') }}
                .text {{ gettext('You must be 18-29 years old at the time of documents submission in order to start a traineeship program') }}
              .trainee-item
                .mdi.mdi-school
                .head {{ gettext('Be student with a focus on agriculture') }}
                .text {{ gettext('You must be enrolled in a second year of agricultural education, with courses of livestock or agronomy') }}
              .trainee-item
                .mdi.mdi-translate
                .head {{ gettext('Speak foreign language') }}
                .text {{ gettext('You must hold a certificate IELTS 3.0 / KET A2 score 120 and higher from English or German language') }}
    section.section-6.gray-bg
      .block-wrap
        .section-6-wrap
          .headline
            span {{ gettext('Our programs') }}
          .countries
            a.country(href="http://bixter.com/traineeship-in-denmark/" target="_blank")
              .img(style="background-image: url(/webapp/images/countries/denmark.png);")
              .filter
              span {{ gettext('Denmark') }}
            a.country(href="http://bixter.com/traineeship-in-germany/" target="_blank")
              .img(style="background-image: url(/webapp/images/countries/germany.png);")
              .filter
              span {{ gettext('Germany') }}
            a.country(href="http://bixter.com/traineeship-in-norway/" target="_blank")
              .img(style="background-image: url(/webapp/images/countries/1.png);")
              .filter
              span {{ gettext('Norway') }}
            a.country(href="http://bixter.com/traineeship-in-switzerland/" target="_blank")
              .img(style="background-image: url(/webapp/images/countries/switzerland2-min.jpg);")
              .filter
              span {{ gettext('Switzerland') }}
          <!-- router-link.btn(:to="`/${getLanguage}/countries`") {{ gettext('More countries') }} -->
    section.section-5
      .block-wrap
        .section-5-wrap
          h3 {{ gettext('Are you still not with us?') }}
          router-link.main-btn.col-white.bg-red(:to="`/${getLanguage}/registration`") {{ gettext('Create an account') }}
    video-modal(
    v-if="showVideoModal"
    :show="showVideoModal"
    @close="showVideoModal = !showVideoModal"
    :isYoutube="false"
    :isVimeo="true"
    :relative="true"
    :iframeSrc="videoFrameSrc"
    videoType="video/mp4"
    )
    v-modal.thank-modal(:show.sync="thankModal" :clickAway="true")
      section.modal-card-body.requestMOdal
        h3.thank-you {{ gettext('Thank you, we will contact you as soon as possible!') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { gettext } from './../../services/TranslateHandler'
import AjaxDropdown from '@/components/ajax-dropdown'
import AjaxMultiselect from '@/components/ajax-multiselect'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import VideoModal from '@/components/video-modal'
import LocationDropdown from '@/components/location-dropdown'
import mixin from '@/mixins'
import slider from './parts/slider'
import workers from './parts/workers'
import jobs from './parts/jobs'
import learn from './parts/learn'
import VPhoneInput from '@/components/v-phone-input'
import { required, email, minValue, maxValue, maxLength } from 'vuelidate/lib/validators'
import VTooltip from 'v-tooltip'
import VModal from '@/components/modal'

const inactive = require('@/constants.json')
const CONSTANTS = require('@/constants.json')
const _ = require('lodash')

export default {
  name: 'AgriculturalTrainee',
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo})
  },
  methods: {
    ...mapActions([
      'sendQuickTraineeship'
    ]),
    gettext: gettext,
    search () {
      let query = {}
      if (this.query) query.q = this.query
      if (this.country) query.c = this.country
      if (this.employer) this.$router.push({name: 'Workers', params: {lang: this.getLanguage}, query: query})
      else this.$router.push({name: 'FindJob', params: {lang: this.getLanguage}, query: query})
    },
    validateData (item) {
      if (item) {
        this.$v.form[item].$touch()
        if (this.$v.form[item].$error) {
          this.$set(this.tooltip, item, true)
        }
        setTimeout(() => {
          this.tooltip[item] = false
        }, 3000)
      } else {
        this.$v.$touch()
        let errors = this.$v.form
        _.each(errors, (item, key) => {
          if (!key.includes('$')) {
            if (errors[key].$error) {
              this.$set(this.tooltip, key, true)
            }
          }
        })
        setTimeout(() => {
          _.each(this.tooltip, (item, key) => {
            this.tooltip[key] = false
          })
        }, 3000)
      }
    },
    clearRequestForm () {
      this.$v.$reset()
      this.form = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        text: '',
        country: '',
        age: '',
        agree: false
      }
    },
    reset () {
      this.$v.$reset()
    },
    clear () {
      this.form = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        text: '',
        country: '',
        age: '',
        agree: false
      }
    },
    send () {
      this.loading = true
      this.validateData()
      this.sendQuickTraineeship({
        lang: this.getLanguage,
        form_data: {
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          email: this.form.email,
          phoneNumber: this.form.phone,
          nationality: this.form.country.id,
          age: parseInt(this.form.age)
        }
      }).then(res => {
        if (res.success) {
          this.sent = true
          this.loading = false
          this.thankModal = true
          this.clearRequestForm()
          setTimeout(() => {
            // this.thankModal = false
          }, 3000)
        }
      })
    }
  },
  components: {
    swiper,
    swiperSlide,
    VideoModal,
    LocationDropdown,
    AjaxDropdown,
    AjaxMultiselect,
    slider,
    workers,
    jobs,
    learn,
    VModal,
    VTooltip,
    VPhoneInput
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    errors () {
      return {
        required: gettext('This field is required')
      }
    },
    computedQuery () {
      if (this.query || this.country) return {q: this.query, c: this.country}
      return {}
    },
    defaultMetaInfo () {
      return {
        title: 'Bixter',
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    },
    link () {
      return 'https://www.youtube.com/embed/hFAVyylnLc4'
    },
    videoFrameSrc () {
      return this.videoFrameSrcByLang[this.getLanguage] || this.videoFrameSrcByLang['_DEFAULT_']
    }
  },
  data () {
    return {
      CONSTANTS: CONSTANTS,
      inactive: inactive,
      showVideoModal: false,
      employer: true,
      country: '',
      query: '',
      form: {
        text: '',
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        agree: false,
        country: '',
        age: ''
      },
      thankModal: false,
      loading: false,
      tooltip: {},
      sent: false,
      showMore: false,
      swiperOption: {
        slidesPerView: 5,
        loop: true,
        loopFillGroupWithBlank: true,
        breakpoints: {
          400: {
            slidesPerView: 1
          },
          550: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 3
          },
          1024: {
            slidesPerView: 4
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      videoFrameSrcByLang: {
        _DEFAULT_: 'https://player.vimeo.com/video/354466836',
        en: 'https://player.vimeo.com/video/354466836',
        da: 'https://player.vimeo.com/video/354466836',
        de: 'https://player.vimeo.com/video/354466836',
        ro: 'https://player.vimeo.com/video/354466836',
        ru: 'https://player.vimeo.com/video/340180605',
        uk: 'https://player.vimeo.com/video/340180605'
      }
    }
  },
  validations () {
    return {
      form: {
        email: {
          email,
          required
        },
        phone: {
          required,
          isUnique () {
            if (this.form.phone === undefined) return true
            return new Promise((resolve) => {
              this.$nextTick(() => {
                resolve(this.$refs.phoneInput.isValidInp)
              })
            })
          }
        },
        firstName: {
          required,
          maxLength: maxLength(100)
        },
        lastName: {
          required,
          maxLength: maxLength(100)
        },
        country: {
          required
        },
        age: {
          required,
          minValue: minValue(14),
          maxValue: maxValue(100)
        }
      }
    }
  }
}
</script>

<style lang="scss" src="./styles.scss"></style>



// WEBPACK FOOTER //
// src/pages/agricultural-trainee/index.vue